<template>
	<div class="timer-container" v-cloak>
		<span v-show="moreThanOneDay">{{displayDays}} {{displayHours}}:{{displayMinutes}}:{{displaySeconds}}</span>
		<span v-show="lessThanOneDay">{{displayHours}}:{{displayMinutes}}:{{displaySeconds}}</span>
	</div>
</template>




<script>
	const HOURS_PER_DAY    = 24;
	const SECS_PER_DAY     = 86400;
	const SECS_PER_HOUR    = 3600;
	const SECS_PER_MINUTE  = 60;
	const MSECS_PER_SECOND = 1000;

	export default {
		data: () => ({
			idTimeout: 0,
			nrSeconds: 0,
			endsAt: 0,
			ended: false
		}),
		props: {
			seconds: { type: Number, required: false, default: 0 },
			emitOnZero: { type: Boolean, default: false }
		},
		created() {
			this.initSeconds();
		},
		mounted() {
			this.visibilityHandler = () => { if (!document.hidden && !this.ended) this.tick(); };
			document.addEventListener('visibilitychange', this.visibilityHandler);
			this.restart();
		},
		beforeUnmount() {
			this.stop();
			document.removeEventListener('visibilitychange', this.visibilityHandler);
		},
		methods: {
			initSeconds() {
				const seconds = Number.isFinite(this.seconds) ? Math.max(0, this.seconds) : 0;
				this.endsAt = Date.now() + seconds * MSECS_PER_SECOND;
				this.nrSeconds = Math.floor(seconds);
				this.ended = false;
			},
			tick() {
				this.stop();
				const remaining = Math.max(0, this.endsAt - Date.now());
				this.nrSeconds = Math.ceil(remaining / MSECS_PER_SECOND);
				if (remaining === 0) {
					if (!this.ended && (this.seconds > 0 || this.emitOnZero)) this.$emit('ended');
					this.ended = true;
				} else {
					this.idTimeout = setTimeout(() => this.tick(), Math.min(remaining, MSECS_PER_SECOND));
				}
			},
			restart() {
				this.tick();
			},
			stop() {
				clearTimeout(this.idTimeout);
				this.idTimeout = 0;
			}
		},
		computed: {
			displayDays() {
				var nrDays = Math.floor(this.nrSeconds / SECS_PER_DAY);
				return `${nrDays}D`;
			},
			displayHours() {
				var nrHours = Math.floor((this.nrSeconds / SECS_PER_HOUR) % HOURS_PER_DAY);
				var strHours = new String(nrHours).padStart(2, '0');
				return strHours;
			},
			displayMinutes() {
				var nrMins = Math.floor((this.nrSeconds / SECS_PER_MINUTE) % SECS_PER_MINUTE);
				var strMins = new String(nrMins).padStart(2, '0');
				return strMins;
			},
			displaySeconds() {
				var nrSecs = Math.floor(this.nrSeconds % SECS_PER_MINUTE);
				var strSecs = new String(nrSecs).padStart(2, '0');
				return strSecs;
			},
			moreThanOneDay() {
				return (this.nrSeconds >= SECS_PER_DAY);
			},
			lessThanOneDay() {
				return !this.moreThanOneDay;
			}
		},
		watch: {
			seconds(newVal, oldVal) {
				this.initSeconds();
				this.restart();
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	div.timer-container {
		display:inline-block;
	}
</style>
